import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import admindata from "../../components/admindata";
import { apiRequest } from "../../apiServices/allApi";

const EditReferralReport = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);

  // ==============================
  // GET REFERRAL REPORT
  // ==============================
  const getReferralReport = async () => {
    const access_token = localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      setLoading(true);

      const res = await apiRequest(
        "admin/referral_update_report",
        "GET",
        null,
        headers,
      );

      if (res?.data?.status) {
        setReports(res.data.data || []);
      } else {
        setReports([]);
      }
    } catch (error) {
      console.log("Referral Report Error:", error);
      setReports([]);
    } finally {
      setLoading(false);
    }
  };

  // ==============================
  // DATE FORMAT
  // ==============================
  const dateFormat = (date) => {
    if (!date) return "N/A";

    const newDate = new Date(date);

    return newDate.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  // ==============================
  // GET REPORT
  // ==============================
  useEffect(() => {
    getReferralReport();
  }, []);

  // ==============================
  // EXPORT EXCEL
  // ==============================
  const handleExport = () => {
    if (!reports || reports.length === 0) {
      return;
    }

    let table1 = [
      {
        A: "Id",
        B: "User Name",
        C: "Phone Number",
        D: "User Referral Code",
        E: "Old Referral",
        F: "New Referral",
        G: "Action By",
        H: "Action By Phone",
        I: "Action By Type",
        J: "Action Type",
        K: "Date",
      },
    ];

    reports.forEach((row) => {
      const userDetails = row.user || {};
      const actionBy = row.action_by || {};

      table1.push({
        A: row._id || "",
        B: userDetails.Name || "",
        C: userDetails.Phone || "",
        D: userDetails.referral_code || "",
        E: row.old_referral || "N/A",
        F: row.new_referral || "N/A",
        G: actionBy.Name || "N/A",
        H: actionBy.Phone || "N/A",
        I: row.action_by_type || actionBy.user_type || "N/A",
        J: row.action_type || "N/A",
        K: dateFormat(row.createdAt),
      });
    });

    const ws = XLSX.utils.json_to_sheet(table1, {
      skipHeader: true,
    });

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Referral Report");

    XLSX.writeFile(wb, "ReferralUpdateReport.xlsx");
  };

  // ==============================
  // REFRESH REPORT
  // ==============================
  const handleRefresh = () => {
    getReferralReport();
  };

  // ==============================
  // LOADING
  // ==============================
  if (loading) {
    return (
      <>
        <div className="row mt-5">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body text-light table_bg text-center">
                <h4 className="text-dark">Loading Referral Reports...</h4>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="row mt-5">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body text-light table_bg">
              {/* =====================================
                  HEADER
              ===================================== */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="d-flex flex-row dashboard_heading mb-0">
                  Referral Update Reports
                </h3>

                <div className="d-flex">
                  <button
                    type="button"
                    onClick={handleRefresh}
                    className="btn btn-secondary mr-2"
                    style={{
                      height: "40px",
                    }}
                  >
                    Refresh
                  </button>

                  <button
                    type="button"
                    onClick={handleExport}
                    className="btn btn-primary"
                    style={{
                      height: "40px",
                    }}
                    disabled={!reports || reports.length === 0}
                  >
                    Export Data
                  </button>
                </div>
              </div>

              {/* =====================================
                  REPORT COUNT
              ===================================== */}
              <div className="mb-3">
                <span className="text-light font-weight-bold">
                  Total Records: {reports?.length || 0}
                </span>
              </div>

              {/* =====================================
                  TABLE
              ===================================== */}
              <div className="table-responsive">
                <table className="table text-light">
                  <thead>
                    <tr>
                      <th>#</th>

                      {localStorage.getItem("id") ===
                      "6931311e30989ed52eebce14" ? (
                        <th>ID</th>
                      ) : (
                        ""
                      )}

                      <th>Phone</th>

                      <th>User</th>

                      <th>User Referral Code</th>

                      <th>Old Referral</th>

                      <th>New Referral</th>

                      <th>Action By</th>

                      {/* <th>Action By Phone</th>

                      <th>Action By Type</th> */}

                      <th>Action</th>

                      <th>Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    {reports && reports.length > 0 ? (
                      reports.map((data, key) => {
                        const userData = data.user || {};
                        const actionBy = data.action_by || {};

                        return (
                          <tr key={data._id || key}>
                            {/* =====================
                                SERIAL NUMBER
                            ===================== */}
                            <td>{key + 1}</td>

                            {/* =====================
                                ID
                            ===================== */}
                            {localStorage.getItem("id") ===
                            "6931311e30989ed52eebce14" ? (
                              <td>{data._id}</td>
                            ) : (
                              ""
                            )}

                            {/* =====================
                                USER PHONE
                            ===================== */}
                            <td>
                              {admindata?.user?.usertype === "Admin" ||
                              admindata?.user?.updateLegalData === true ? (
                                <span className="pl-2">
                                  {userData?.Phone || "N/A"}
                                </span>
                              ) : (
                                <span className="pl-2">
                                  {userData?.Phone
                                    ? "********" +
                                      userData.Phone.toString().slice(-2)
                                    : "N/A"}
                                </span>
                              )}
                            </td>

                            {/* =====================
                                USER NAME
                            ===================== */}
                            <td>
                              {userData?._id ? (
                                <Link
                                  className="btn btn-sm btn-outline-info"
                                  to={`/user/view_user/${userData._id}`}
                                >
                                  {userData?.Name || "N/A"}
                                </Link>
                              ) : (
                                <span>N/A</span>
                              )}
                            </td>

                            {/* =====================
                                USER REFERRAL CODE
                            ===================== */}
                            <td>
                              <span className="font-weight-bold">
                                {userData?.referral_code || "N/A"}
                              </span>
                            </td>

                            {/* =====================
                                OLD REFERRAL
                            ===================== */}
                            <td>
                              {data?.old_referral ? (
                                <span className="text-warning font-weight-bold">
                                  {data.old_referral}
                                </span>
                              ) : (
                                <span className="text-muted">Empty</span>
                              )}
                            </td>

                            {/* =====================
                                NEW REFERRAL
                            ===================== */}
                            <td>
                              {data?.new_referral ? (
                                <span className="text-success font-weight-bold">
                                  {data.new_referral}
                                </span>
                              ) : (
                                <span className="text-muted">Empty</span>
                              )}
                            </td>

                            {/* =====================
                                ACTION BY
                            ===================== */}
                            <td>
                              {actionBy?._id ? (
                                <span className="font-weight-bold">
                                  {actionBy?.Name || "N/A"}
                                </span>
                              ) : (
                                "N/A"
                              )}

                              <span className="font-weight-bold">
                                -- ({" "}
                                {data?.action_by_type ||
                                  actionBy?.user_type ||
                                  "N/A"}
                                )
                              </span>
                            </td>

                            {/* =====================
                                ACTION BY PHONE
                            ===================== */}
                            {/* <td>{actionBy?.Phone || "N/A"}</td> */}

                            {/* =====================
                                ACTION TYPE
                            ===================== */}
                            <td>
                              {data?.action_type === "REMOVE" ? (
                                <span className="badge badge-danger">
                                  REMOVE
                                </span>
                              ) : (
                                <span className="badge badge-success">
                                  UPDATE
                                </span>
                              )}
                            </td>

                            {/* =====================
                                DATE
                            ===================== */}
                            <td>{dateFormat(data?.createdAt)}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center text-light">
                          No Referral Update Records Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditReferralReport;
